var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        width: "100%",
        height: "100%",
        viewBox: "0 0 37 37",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
      },
    },
    [
      _c("circle", {
        attrs: { cx: "18.8398", cy: "18.3242", r: "18", fill: "#FB8800" },
      }),
      _c("path", {
        attrs: {
          d: "M27.406 11.6983L26.8747 11.167L23.1647 7.45659C23.1643 7.4562 23.1643 7.4562 23.1639 7.4562L22.8633 7.15523C22.7248 7.01704 22.5409 6.94092 22.3453 6.94092H11.0162C10.4857 6.94092 10.0547 7.37227 10.0547 7.90239V22.1651V28.6206C10.0547 29.1507 10.4857 29.5821 11.0162 29.5821H26.6596C27.1897 29.5821 27.6211 29.1507 27.6211 28.6206V22.1651V12.2167C27.6211 12.0235 27.5426 11.8341 27.406 11.6983ZM22.9367 11.6253V8.33257L26.2294 11.6253H25.2789H22.9367ZM23.3271 12.406H24.3932C24.2581 12.6391 24.0059 12.7964 23.7174 12.7964C23.4352 12.7964 23.1893 12.6445 23.0523 12.4201C23.1428 12.4119 23.2342 12.406 23.3271 12.406ZM26.8404 28.6206C26.8404 28.7201 26.7592 28.8013 26.6596 28.8013H11.0162C10.9166 28.8013 10.8354 28.7201 10.8354 28.6206V22.9459H26.8404V28.6206ZM10.8354 22.1651V7.90239C10.8354 7.80284 10.9166 7.72165 11.0162 7.72165H22.1786C22.1657 7.77083 22.156 7.82158 22.156 7.87428V11.6253V11.8053C20.9572 12.1831 20.0078 13.1255 19.6178 14.3192C19.3497 14.1025 19.0136 13.9675 18.6427 13.9675C17.917 13.9675 17.3112 14.4671 17.1367 15.1386H15.9102V14.3578H13.568V16.7H15.9102V15.9193H17.0504C16.9192 16.9588 16.2755 17.8625 15.3371 18.3251C15.0763 17.8258 14.5595 17.4808 13.9583 17.4808C13.0972 17.4808 12.3969 18.1811 12.3969 19.0422C12.3969 19.9034 13.0972 20.6037 13.9583 20.6037C14.7961 20.6037 15.4761 19.9393 15.5128 19.1105C16.5492 18.6612 17.3268 17.7884 17.6691 16.7398C17.9369 16.9557 18.2726 17.0904 18.6427 17.0904C19.3684 17.0904 19.9742 16.5907 20.1487 15.9193H21.3753V16.7H23.7174V14.3578H21.3753V15.1386H20.2311C20.3791 13.9601 21.1852 12.9861 22.2696 12.5942C22.5007 13.1692 23.0609 13.5771 23.7174 13.5771C24.4431 13.5771 25.049 13.0774 25.2235 12.406H26.6873C26.74 12.406 26.7908 12.3963 26.8404 12.3834V22.1651H10.8354ZM19.4234 15.5289C19.4234 15.9595 19.0733 16.3097 18.6427 16.3097C18.2121 16.3097 17.862 15.9595 17.862 15.5289C17.862 15.0984 18.2121 14.7482 18.6427 14.7482C19.0733 14.7482 19.4234 15.0984 19.4234 15.5289ZM15.1294 15.9193H14.3487V15.1386H15.1294V15.9193ZM14.7391 19.0422C14.7391 19.4728 14.3889 19.8229 13.9583 19.8229C13.5278 19.8229 13.1776 19.4728 13.1776 19.0422C13.1776 18.6116 13.5278 18.2615 13.9583 18.2615C14.3889 18.2615 14.7391 18.6116 14.7391 19.0422ZM22.156 15.1386H22.9367V15.9193H22.156V15.1386Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M16.6978 27.2039H18.1761L18.4587 28.0205H19.1204L17.7541 24.0923H17.119L15.7422 28.0205H16.4093L16.6978 27.2039ZM17.4395 25.0744L18.0211 26.7717H16.8469L17.4395 25.0744Z",
          fill: "white",
        },
      }),
      _c("path", {
        attrs: {
          d: "M20.6082 24.0874H19.957V28.0207H20.6082V24.0874Z",
          fill: "white",
        },
      }),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }